export default __webpack_public_path__ + "static/media/cadence-thumbnail.555e5bd8.png";